// extracted by mini-css-extract-plugin
export var chevron = "_8r-2";
export var dropdownItems = "_8r-0";
export var item = "_8r-1";